import type { LinkDescriptor } from '@remix-run/node';

export const fontPreconnectLinks: LinkDescriptor[] = [
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
];
